import { useEffect } from 'react'

interface UseKeyboardShortcutArgs {
    key: string
    onKeyPressed: () => void
    isEnabled: boolean
}

export const useKeyboardShortcut = ({
    key,
    onKeyPressed,
    isEnabled
}: UseKeyboardShortcutArgs) => {
    useEffect(() => {
        function keyDownHandler(e: globalThis.KeyboardEvent) {
            const target = e.target as HTMLElement

            // Don’t trigger if focus is on an input, textarea, or editable element
            const isInputFocused =
                target.tagName === 'INPUT' ||
                target.tagName === 'TEXTAREA' ||
                target.isContentEditable;

            if (e.key === key && isEnabled && !isInputFocused) {
                e.preventDefault();
                onKeyPressed();
            }
        }

        document.addEventListener('keydown', keyDownHandler);

        return () => {
            document.removeEventListener('keydown', keyDownHandler);
        };
    }, [key, onKeyPressed, isEnabled]);
}
